import { Components } from '@mui/material/styles';
import fonts from '../fonts';
import { Theme } from '@mui/material';
import palette from '../palette';

const MuiButton = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      ...fonts.button,
      textTransform: 'none',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: 1,
      borderRadius: 8,
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&:disabled': {
        boxShadow: 'none',
        opacity: 0.6
      }
    }),
    containedPrimary: {
      background: '#FFFFFFB8',
      color: palette.common.black,
      textTransform: 'uppercase'
    },
    containedSizeMedium: {
      padding: '20px 24px'
    },
    containedSecondary: {
      color: palette.common.black,
      textTransform: 'uppercase'
    },
    containedInfo: {
      background: '#4E26FF',
      color: palette.primary.main,
      fontSize: 16,
      lineHeight: 1,
      borderRadius: 50
    },
    outlinedPrimary: {
      borderColor: palette.common.white,
      color: palette.common.white,
      borderWidth: 2,
      '&:hover, &:disabled': {
        borderWidth: 2,
        borderColor: palette.common.white,
        color: palette.common.white
      }
    },
    outlinedSecondary: {
      borderColor: palette.primary.contrastText,
      color: palette.primary.contrastText,
      '&:hover, &:disabled': {
        borderColor: palette.primary.contrastText,
        color: palette.primary.contrastText
      }
    }
  }
} as Components['MuiButton'];

export default MuiButton;
